import { waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkNotOk, renderQuestionOkNotOkNa } from "../shared/templates";

const app = window.app;

export class MbOutVehicleSettings extends HTMLElement {
	async connectedCallback() {
		await waitForContent("mbOutVehicleSettings");
		this.innerHTML = app.content.mbOutVehicleSettings;

		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton15", "nextButton15"));

		//prettier-ignore
		const questions = [
			["mer-out-headlights", "Headlights: Auto",               false],
			["mer-out-wipers",     "Wipers: Auto",                   false],
			["mer-out-hvac",       "HVAC: 72°F, Auto fan speed",     false],
			["mer-out-vents",      "HVAC vents opened and uniform",  false],
			["mer-out-volume",     "Volume low: < 30% range",        false],
			["mer-out-sun",        "Sunroof and sunshade closed",     true],
			["mer-out-mats",       "Floormats fastened"              ],
		];

		for (const [name, label, na] of questions) {
			const render = na ? renderQuestionOkNotOkNa : renderQuestionOkNotOk;
			this.querySelector(`#${name}-slot`).replaceWith(render(name, label, 15));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(15, pageElement);
		});
		this.addEventListener("ionViewDidEnter", async () => {
			const currentRoute = app.routes.mbOutVehicleSettings;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
